var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lang"},[_c('button',{staticClass:"button",on:{"click":function($event){return _vm.openDialogue()}}},[_vm._v(_vm._s(_vm.regionLabel)+": "),_c('span',{staticClass:"upcase"},[_vm._v(_vm._s(_vm.language))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }